<template>
  <div class="rb-ob-form rb-match-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.rematchReviewTitle') }}</h1>
    </header>

    <div class="rb-match-progress" data-rematch-loading>
      <div v-if="loading" class="rb-match-orb" aria-hidden="true"></div>
      <p v-if="loading" class="rb-ob-q">{{ $t('intake.portal.loading') }}</p>
      <p v-else-if="pendingMessage" class="rb-ob-q" role="status">{{ pendingMessage }}</p>
    </div>

    <div class="rb-ob-actions">
      <button
          class="rb-ob-submit"
          type="button"
          :disabled="loading"
          :class="{ 'is-loading': loading }"
          @click="checkStatus"
      >
        {{ loading ? $t('intake.portal.loading') : $t('intake.rematchReviewRefresh') }}
      </button>
      <router-link class="rb-ob-submit rb-ob-submit-secondary" :to="{name: 'portalHome', params: {lang}}">{{ $t('intake.rematchBackToCareAction') }}</router-link>
      <router-link class="rb-ob-submit rb-ob-submit-secondary" :to="{name: 'portalSupport', params: {lang}}">{{ $t('intake.rematchSupportAction') }}</router-link>
      <p class="rb-ob-status" role="status" aria-live="polite">{{ formStatus }}</p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {hasAuthToken, fetchActiveClinicalResponse} from '@/intake/portalApi'

export default {
  name: 'RematchRunStep',
  data() { return {loading: true, formStatus: '', rematchStatus: ''} },
  computed: {
    lang() { return this.$route.params.lang || 'fa' },
    pendingMessage() {
      if (this.rematchStatus === 'MANUAL_REVIEW_REQUIRED') return this.$t('intake.rematchManualReviewPending')
      if (this.rematchStatus === 'FINANCIAL_RESOLUTION_REQUIRED') return this.$t('intake.rematchValueReviewPending')
      if (this.rematchStatus === 'SAFETY_APPROVAL_REQUIRED') return this.$t('intake.rematchSafetyReviewPending')
      if (this.rematchStatus === 'SAFETY_BLOCKED') return this.$t('intake.rematchSafetyBlocked')
      return ''
    },
  },
  created() { this.startRematch() },
  methods: {
    startRematch() {
      if (!hasAuthToken()) { this.loading = false; this.formStatus = this.$t('intake.portal.needsLogin'); return }
      this.loading = true
      this.formStatus = ''
      this.rematchStatus = ''
      return fetchActiveClinicalResponse().then((data) => {
        const rematch = data && data.rematch
        this.rematchStatus = rematch && rematch.status || ''
        if (['MANUAL_REVIEW_REQUIRED', 'FINANCIAL_RESOLUTION_REQUIRED', 'SAFETY_APPROVAL_REQUIRED', 'SAFETY_BLOCKED'].includes(this.rematchStatus)) return
        if (this.rematchStatus === 'OFFERED') {
          this.$router.replace({name: 'intakeRematchOffer', params: {lang: this.lang}})
          return
        }
        if (!rematch || !['ACCEPTED_PENDING_REQUIREMENTS','MATCH_FAILED','NO_SUPPLY','MATCH_READY'].includes(rematch.status)) {
          throw new Error('CLINICAL_REMATCH_NOT_READY')
        }
        // Never reuse an old snapshot here. The normal screening flow creates a new authoritative snapshot;
        // MatchLoadingStep detects the accepted rematch and invokes the server-side rematch matcher.
        this.$router.replace({name: 'intakeScreening', params: {lang: this.$route.params.lang || 'fa'}, query: {restart: '1'}})
      }).catch(() => { this.formStatus = this.$t('intake.rematchRunFail') }).finally(() => { this.loading = false })
    },
    checkStatus() { if (!this.loading) this.startRematch() },
  },
}
</script>
